<template lang="html">
  <div class="component-wrapper">
    <v-main >
      <ParallaxIceverg />
      <h1 class="text-center">Política de Privacidad</h1>
      <section class="container flex">
        <p>
        En <b>ICEVERG</b> se garantiza un nivel apropiado de protección de las personas físicas titulares de los datos, conforme se establece en el Reglamento General de Protección de datos (679/2016) con total lealtad, licitud y transparencia.
        A continuación, le facilitamos la información relativa al tratamiento de sus datos personales:
        </p>

        <h3>Responsable del tratamiento</h3>
        <ol>
          <li>Identidad: ICEVERG</li>
          <li>CIF: B67538512 </li>
          <li>Dirección Postal: C/ Bellaterra 6, Cornellà del Llobregat</li>
          <li>Correo electrónico: info@iceverg.com</li>
        </ol>


        <h3>Finalidad del tratamiento de sus datos y conservación:</h3>
        <p>En <b>ICEVERG</b> trataremos sus datos para atender sus solicitudes de información a través de nuestro formulario y email de contacto. </p>

        <h3>Legitimación para el tratamiento</h3>
        <p>La base legal para el tratamiento de sus datos es el consentimiento del Usuario es al solicitarnos información a través de la dirección de correo electrónico.</p>

        <h3>Destinatarios de sus datos</h3>
        <p>Sus datos no serán cedidos a terceros excepto en el caso de existir una obligación legal.</p>

        <h3>Derechos del interesado</h3>
        <p>Como usuario de <b>ICEVERG</b>, tiene derecho a:
          <ol>
            <li>Acceder, rectificar o solicitar la supresión de sus datos, en el momento que crea que no son necesarios para el fin que fueron recogidos.</li>
            <li>Solicitar la limitación del tratamiento, en este caso solo se conservarán los estrictamente necesarios para llevar al ejercicio reclamaciones.</li>
            <li>Retirar su consentimiento, en cualquier momento.</li>
          </ol>
        </p>
        <p>Para proceder al ejercicio de derechos debe ponerse en contacto con nosotros en nuestra dirección de correo electrónico info@iceverg.com.  </p>
        <p>Si considera que sus derechos de protección de datos han sido vulnerados tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos a través de su sitio web <a href="https://www.aepd.es">www.aepd.es</a>.</p>

      </section>
    </v-main>
    <Footer />
  </div>
</template>

<script>
import ParallaxIceverg from '@/components/sections/ParallaxIceverg';
import Footer from '@/components/Footer';
  export default {
    name: "Legal",
    components: {
      ParallaxIceverg,
      Footer
    }
  }
</script>

<style lang="css">
h1{
  padding-top: 50px;
}
p{
  padding-top: 15px
}
h3{
  margin-top:35px;
}
</style>
